// extracted by mini-css-extract-plugin
export default {"headerContainer":"header_headerContainer__s9UYF","headerText":"header_headerText__XhQ39"};